@if (selectedGroup) {
  <h1 class="page-title">{{ selectedGroup.groupName }}</h1>
  <div class="group-details-buttons">
    <button
      class="btn"
      (click)="this.groupsService.openGroupsOverview()"
      aria-label="Back to Groups Overview"
      >
      <app-icon name="arrow_left" /> Back to overview
    </button>
    <!-- Delete Group Button -->
    <button
      (click)="deleteGroup(selectedGroup)"
      class="btn btn-delete"
      matTooltip="Delete this group"
      matTooltipPosition="above"
      >
      <app-icon name="trash"></app-icon>
      Delete this group
    </button>
  </div>
  <div class="grid-container">
    <app-card title="Invitation Code:">
      <div class="action-row">
        <span class="group-code">{{ selectedGroup.groupCode }}</span>
        <button
          mat-icon-button
          ngxClipboard
          [cbContent]="selectedGroup.groupCode"
          matTooltip="Copy to clipboard"
          matTooltipPosition="above"
          >
          <app-icon name="copy" color="black"></app-icon>
        </button>
      </div>
    </app-card>
    <app-card title="Tracking Period:">
      <div class="action-row">
        {{ selectedGroup.trackingPeriodStart | date : "dd.MM.yyyy" }} -
        {{ selectedGroup.trackingPeriodFinish | date : "dd.MM.yyyy" }}
        <button
          (click)="
            this.groupsService.openCreateOrEditGroupDialog(selectedGroup)
          "
          mat-icon-button
          matTooltip="Edit Tracking Period"
          matTooltipPosition="above"
          >
          <app-icon name="edit" color="#000"></app-icon>
        </button>
      </div>
    </app-card>
    <app-card title="Group Administrators:">
      @if (admins && admins.length > 0) {
        <div
          class="student-table-container"
        ></div>
      }
      @if (admins.length > 0) {
        <div>
          @for (admin of admins; track admin) {
            <div class="action-row">
              <span class="action-name">{{ admin.email }}</span>
              <button
                (click)="changeAdminRights(admin, false)"
                mat-icon-button
                matTooltip="Remove Admin Rights"
                matTooltipPosition="above"
                >
                <app-icon name="trash" color="#000"></app-icon>
              </button>
            </div>
          }
        </div>
      }
    </app-card>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
<ng-container>
  <app-card title="Participants">
    <!-- Display message that there are no participants yet if there are none -->
    @if (participants.length === 0) {
      <div>
        <p>
          No students in this group yet. Share The Group code with your students
          so that they can join this group.
        </p>
      </div>
    }
    <!-- Display the list of students in the group -->
    <div class="table-container">
      @if (participants.length > 0 && !isLoading) {
        <div>
          <table mat-table [dataSource]="dataSource" class="admin-table">
            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let participant">
                {{ participant.email }}
              </td>
            </ng-container>
            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let participant">
                {{ participant.firstName }}
              </td>
            </ng-container>
            <!-- Last Name Column -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let participant">
                {{ participant.lastName }}
              </td>
            </ng-container>
            <!-- Status Daily Logs -->
            <ng-container matColumnDef="statusDailyLogs">
              <th mat-header-cell *matHeaderCellDef>Daily Logs</th>
              <td mat-cell *matCellDef="let participant">
                {{
                participant.dailyProgress
                ? displayDailyProgress(participant.dailyProgress)
                : "No daily logs yet"
                }}
              </td>
            </ng-container>
            <!-- Status General Emissions -->
            <ng-container matColumnDef="statusGeneralLogs">
              <th mat-header-cell *matHeaderCellDef>General Emissions</th>
              <td mat-cell *matCellDef="let participant">
                {{ displayBaselineProgress(participant.baselineProgress) }}
              </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let participant">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="participantMenu"
                  aria-label="Participant actions"
                  >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #participantMenu="matMenu">
                  <button
                    mat-menu-item
                    (click)="inspectUserEmissions(participant)"
                    >
                    <mat-icon>analytics</mat-icon>
                    <span>Inspect User's Emissions</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="changeAdminRights(participant, true)"
                    >
                    <mat-icon>admin_panel_settings</mat-icon>
                    <span>Grant Admin Rights</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="removestudentFromGroup(participant)"
                    >
                    <mat-icon>delete</mat-icon>
                    <span>Remove User From Group</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      }
      <mat-paginator
        #paginator
        [pageSizeOptions]="[5, 10, 20]"
        [pageSize]="10"
        showFirstLastButtons
        (page)="updatePaginator()"
        aria-label="Select page of participants"
        >
      </mat-paginator>
    </div>
  </app-card>
</ng-container>
